import React, {Component} from "react";
import Layout from "../../containers/Layout";
import Title from "../../components/Title";
import Breadcrumbs from "../../components/UI/Breadcrumbs";
import BonusRateContainer from "../../containers/BonusRate";

class BonusRatePage extends Component {
    render() {
        return (
            <Layout>
                <Title>Настройки - Бонусная сетка</Title>
                <Breadcrumbs links={[
                    {name: 'Главная', url: '/'},
                    {name: 'Настройки - Бонусная сетка', url: '/settings/bonus-rate'}
                ]}/>
                <BonusRateContainer/>
            </Layout>
        );
    }
}

export default BonusRatePage